const $ = window.jQuery;
export const updateSku = () => {

    const $variationsForm = $('.variations_form');
    $variationsForm.on('found_variation', function(event, variation) {
            if (variation.sku) {
                $('.sku').text(variation.sku);
            } else {
                $('.sku').text('Невідомо');
            }
            if (variation.dimensions_html) {
                $('.product_dimensions').html(variation.dimensions_html);
            }
            if (variation.weight_html) {
                $('.product_weight').html(variation.weight_html);
            }
        });

    $variationsForm .on('reset_data', function() {
            $('.sku').text('Невідомо');
            $('.product_dimensions').text('Невідомо');
        });
}